module.exports = __webpack_public_path__ + "img/optimismo.54f0dfc7.png";